import { Sparkles, Star } from "lucide-react";

export default function Hero({ content }) {
  const hero = content?.hero || {};

  return (
    <section
      id="hero"
      className="relative pt-28 md:pt-32 pb-16 md:pb-24 overflow-hidden bg-cream"
      data-testid="hero-section"
    >
      {/* Striped backdrop */}
      <div className="absolute inset-0 bg-stripes-blue-soft opacity-60" />
      <div className="absolute inset-0 bg-noise" />

      {/* Floating decorations */}
      <div className="absolute top-32 left-6 md:left-16 float opacity-70 hidden md:block">
        <Sparkles size={42} style={{ color: "var(--ff-peach)" }} />
      </div>
      <div className="absolute top-44 right-10 md:right-24 float opacity-70 hidden md:block" style={{ animationDelay: "1.2s" }}>
        <Star size={36} fill="var(--ff-sky)" stroke="var(--ff-sky)" />
      </div>
      <div className="absolute bottom-24 left-1/4 float opacity-60 hidden lg:block" style={{ animationDelay: "2.4s" }}>
        <Sparkles size={28} style={{ color: "var(--ff-sky)" }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 text-center">
        <div className="fade-up inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border-2 border-[var(--ff-peach)] mb-6 md:mb-8">
          <Sparkles size={16} style={{ color: "var(--ff-peach)" }} />
          <span className="font-display text-sm font-semibold tracking-wide uppercase" style={{ color: "var(--ff-text)" }}>
            {hero.eyebrow || "Festas Inesquecíveis"}
          </span>
        </div>

        <h1
          className="fade-up delay-100 title-balloon text-6xl sm:text-7xl md:text-8xl lg:text-[10rem] leading-[0.9] mb-2"
          style={{ color: "var(--ff-text)" }}
          data-testid="hero-title-top"
        >
          {hero.title_top || "Fantastic"}
        </h1>
        <h1
          className="fade-up delay-200 title-balloon text-6xl sm:text-7xl md:text-8xl lg:text-[10rem] leading-[0.9] mb-8"
          style={{ color: "var(--ff-peach)" }}
          data-testid="hero-title-bottom"
        >
          {hero.title_bottom || "Fun"}
        </h1>

        <p
          className="fade-up delay-300 max-w-2xl mx-auto text-base md:text-xl leading-relaxed mb-10 font-body"
          style={{ color: "var(--ff-text-soft)" }}
          data-testid="hero-subtitle"
        >
          {hero.subtitle}
        </p>

        <div className="fade-up delay-400 flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <a href="#reservar" className="ff-btn ff-btn-primary" data-testid="hero-cta-primary">
            {hero.cta_primary || "Verificar Disponibilidade"}
          </a>
          <a href="#itens" className="ff-btn ff-btn-ghost" data-testid="hero-cta-secondary">
            {hero.cta_secondary || "Ver os Nossos Itens"}
          </a>
        </div>

        {/* Hero images */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto fade-up delay-400">
          {hero.hero_image && (
            <div className="frame-scallop hover-zoom w-full max-w-sm mx-auto">
              <div className="frame-inner aspect-[4/3] hover-zoom-img">
                <img
                  src={hero.hero_image}
                  alt="Castelo insuflável"
                  className="w-full h-full object-cover"
                  data-testid="hero-image-1"
                  onError={(e) => { e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23f1f5f9' width='400' height='300'/%3E%3Ctext fill='%2394a3b8' font-family='sans-serif' font-size='16' x='200' y='150' text-anchor='middle' dominant-baseline='middle'%3ESem imagem%3C/text%3E%3C/svg%3E"; }}
                />
              </div>
            </div>
          )}
          {hero.side_image && (
            <div className="frame-scallop frame-scallop-blue hover-zoom w-full max-w-sm mx-auto">
              <div className="frame-inner aspect-[4/3] hover-zoom-img">
                <img
                  src={hero.side_image}
                  alt="Carrinho de festa"
                  className="w-full h-full object-cover"
                  data-testid="hero-image-2"
                  onError={(e) => { e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23f1f5f9' width='400' height='300'/%3E%3Ctext fill='%2394a3b8' font-family='sans-serif' font-size='16' x='200' y='150' text-anchor='middle' dominant-baseline='middle'%3ESem imagem%3C/text%3E%3C/svg%3E"; }}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Bottom ribbon */}
      <div className="ribbon-divider mt-16" />
    </section>
  );
}
